module.exports = __webpack_public_path__ + "img/gby.be9003b3.png";